import React from 'react';
import { Container } from 'react-bootstrap';
import LogoWhiteIcon from "../../assets/images/logo-white.svg";
import TwitterIcon from "../../assets/images/twitter.svg";
import InstagramIcon from "../../assets/images/instagram.svg";
import LinkedInIcon from "../../assets/images/linkedin.svg";
import YoutubeIcon from "../../assets/images/youtube.svg";

export default function FooterIndex() {
  return (
    <footer className="footer-section">
      <Container>
        <div className="footer-top">
          <div className="footer-brand">
            <img src={LogoWhiteIcon} alt="Imergey" className="footer-logo" />
            <p className="footer-brand-desc">
IMERGEY is a brand consulting firm that specializes in providing data-informed research and insights to help business and technology leaders accelerate growth and achieve outstanding results. our research and insights provide the foundation for effective strategies that drive success.            </p>
            <div className="social-bar-icons">
              <a href="https://x.com/imergey" target="_blank" rel="noopener noreferrer" className="footer-social-btn" aria-label="X (Twitter)">
                <img src={TwitterIcon} alt="X" />
              </a>
              <a href="https://www.instagram.com/imergey.global/" target="_blank" rel="noopener noreferrer" className="footer-social-btn" aria-label="Instagram">
                <img src={InstagramIcon} alt="Instagram" />
              </a>
              <a href="https://www.linkedin.com/company/imergey/" target="_blank" rel="noopener noreferrer" className="footer-social-btn" aria-label="LinkedIn">
                <img src={LinkedInIcon} alt="LinkedIn" />
              </a>
              <a href="https://www.youtube.com/@IMERGEY" target="_blank" rel="noopener noreferrer" className="footer-social-btn" aria-label="YouTube">
                <img src={YoutubeIcon} alt="YouTube" />
              </a>
            </div>
          </div>

          <nav className="footer-nav" aria-label="Footer navigation">
            <div className="footer-nav-col">
              <span className="footer-nav-title">Product</span>
              <a href="#whatwedo" className="footer-nav-link">What we do</a>
              <a href="#howitwork" className="footer-nav-link">How it works</a>
              <a href="/book-demo" className="footer-nav-link">Pricing</a>
              <a href="#faq" className="footer-nav-link">FAQ</a>
            </div>
            <div className="footer-nav-col">
              <span className="footer-nav-title">Access</span>
              <a href={process.env.REACT_APP_CLIENT_SIGNUP_URL || '#'} className="footer-nav-link" target="_blank" rel="noopener noreferrer">Start free trial</a>
              <a href={process.env.REACT_APP_BRAND_LOGIN_URL || '#'} className="footer-nav-link" target="_blank" rel="noopener noreferrer">Brand Login</a>
              <a href={process.env.REACT_APP_CLIENT_LOGIN_URL || '#'} className="footer-nav-link" target="_blank" rel="noopener noreferrer">Client Login</a>
            </div>
          </nav>
        </div>

        <div className="footer-bottom">
          <div className="trms-text-line">
            <a href="/terms" className="footer-nav-link">Terms &amp; Conditions</a>
            <a href="/privacy" className="footer-nav-link">Privacy Policy</a>
          </div>
          <div className="copyright-text">
            <p>Copyright &copy; 2026 IMERGEY Global. All rights reserved.</p>
          </div>
        </div>
      </Container>
    </footer>
  );
}
